import MelonHeader from "@/components/feature/MelonHeader";
import MelonFooter from "@/components/feature/MelonFooter";
import BackTop from "@/components/feature/BackTop";
import Hero from "@/pages/home/components/Hero";
import Ticker from "@/pages/home/components/Ticker";
import HotTrend from "@/pages/home/components/HotTrend";
import CategoryField from "@/pages/home/components/CategoryField";
import FeedFollow from "@/pages/home/components/FeedFollow";
import ReversalTimeline from "@/pages/home/components/ReversalTimeline";
import ComingNext from "@/pages/home/components/ComingNext";
import About from "@/pages/home/components/About";
import Faq from "@/pages/home/components/Faq";
import SubscribeForm from "@/pages/home/components/SubscribeForm";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <MelonHeader />
      <main>
        <Hero />
        <Ticker />
        <HotTrend />
        <CategoryField />
        <FeedFollow />
        <ReversalTimeline />
        <ComingNext />
        <About />
        <Faq />
        <SubscribeForm />
      </main>
      <MelonFooter />
      <BackTop />
    </div>
  );
}